<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="专家信息"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto',minWidth: form_min_width,}" autocomplete="off">
            <el-form-item label="专家姓名" prop="user_name">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入专家姓名" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
                <el-input type="text" v-model="ruleForm.mobile" maxlength="11" placeholder="请输入手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码">
                <el-input type="text" v-model="ruleForm.idcard" maxlength="18" placeholder="请输入身份证号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="年龄">
                <el-input type="text" v-model="ruleForm.age" placeholder="请输入身份证号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
                <el-input type="text" v-model="ruleForm.bank_card" placeholder="请输入银行卡号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="开户行">
                <el-input type="text" v-model="ruleForm.bank_name" placeholder="请输入银行卡开户行" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="hospital">
                <el-select  v-model="ruleForm.hospital" placeholder="请选择单位"
                           style="width:100%;">
                    <el-option
                        v-for="item in allHospital"
                        :key="item.hospital_nick_name"
                        :label="item.hospital_nick_name"
                        :value="item.hospital_nick_name"
                    v-if="item.hospital_nick_name"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="科室" prop="hospital_department">
                <el-select  v-model="ruleForm.hospital_department"
                           placeholder="请选择科室"
                           style="width:100%;">
                    <el-option
                        v-for="item in hospitalDeparment "
                        :key="item.department_name"
                        :label="item.department_name"
                        :value="item.department_name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="职称" prop="doctor_title">
                <el-select v-model="ruleForm.doctor_title" placeholder="请选择职称"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allDoctorTitle "
                        :key="item.title_name"
                        :label="item.title_name"
                        :value="item.title_name"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="学位" prop="degree">
                <el-input type="text" v-model="ruleForm.degree" placeholder="请输入学位" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>

            <el-form-item label="现任职务">
                <el-input type="textarea" v-model="ruleForm.posistion" placeholder="请输入现任职务" autosize autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="专长" prop="strengths">
                <el-input type="textarea" v-model="ruleForm.strengths"
                          maxlength="1000"
                          show-word-limit
                          placeholder="请输入擅长" autosize autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="学术任职" prop="introduction">
                <el-input type="textarea" v-model="ruleForm.introduction" placeholder="请输入简介"
                          autosize
                          maxlength="1000"
                          show-word-limit
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="编组">
                <el-input type="text" v-model="ruleForm.group_name" placeholder="请输入专家编组"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="排序序号">
                <el-input type="text" v-model="ruleForm.sort" placeholder="请输入排序序号"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="协议编号">
                <el-input type="text" v-model="ruleForm.contract_title" placeholder="请输入协议编号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="签约日期" prop="start_date">
                <el-date-picker v-model="ruleForm.start_date" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" @change="getExpiredDate(ruleForm.is_expired)">
                </el-date-picker>
            </el-form-item>
            <!--            <el-form-item label="签约协议上传" :label-width="formLabelWidth" style="transform: translateX(2em)">-->
            <!--                <el-upload-->
            <!--                    ref="upload"-->
            <!--                    class="upload-demo"-->
            <!--                    accept=".PNG,.JPG,.JPEG,.JPEG,.png,.jpg,.pdf"-->
            <!--                    :action="upload_path"-->
            <!--                    :file-list="fileList"-->
            <!--                    :multiple="true"-->
            <!--                    :limit="9"-->
            <!--                    :on-remove="handleRemove"-->
            <!--                    :on-success="handleSuccess"-->
            <!--                    list-type="picture">-->
            <!--                    <el-button size="small" type="primary">点击上传</el-button>-->
            <!--                    <div slot="tip" class="el-upload__tip">注：支持PNG,JGP,PDF文件格式</div>-->
            <!--                </el-upload>-->
            <!--            </el-form-item>-->
            <el-form-item label="签约协议文件" :label-width="formLabelWidth" style="transform: translateX(2em)">
                <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG,.pdf,.PDF"
                           :action="upload_agreement_path" :file-list="fileList"
                           :on-success="handleSuccess" :before-upload="beforeAvatarUpload" list-type="picture"
                           :multiple="true" :limit="9">
                    <div slot="file" slot-scope="{file}">
                        <pdf class="el-upload-list__item-thumbnail" v-if="file.name.endsWith('.pdf')"
                             :src="file.url"></pdf>
                        <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                        <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>
                        <label class="el-upload-list__item-status-label">
                            <i class="el-icon-upload-success el-icon-check"></i>
                        </label>
                        <i class="el-icon-close" @click="handleRemoveFile(file)"></i>
                        <i class="el-icon-close-tip">按 delete 键可删除</i>
                    </div>

                    <el-button class="upload_btn" size="small" type="primary" v-if="addFileList.length < 9">点击上传
                    </el-button>
                    <div slot="tip" class="el-upload__tip" v-if="addFileList.length < 9">注：格式支持PNG,JPG,PDF
                    </div>
                </el-upload>

                <div class="upload-demo">
                    <el-button class="file_view" size="small" type="primary"
                               @click="oneReservationDetail({contract_file: JSON.stringify(addFileList)})">预览协议
                    </el-button>
                </div>

            </el-form-item>
            <el-form-item label="头像" prop="user_avatar">
                <div class="avatar-uploader">
                    <label class="avatar-btn avatar" for="uploads">
                        <img style=" width: 200px;height: 200px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>
            <el-form-item label="身份证照片">
                <div>
                    <div style="float: left;margin-left: 2px;">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_up" placeholder="身份证正面照片"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                            :action="upload_path"
                            :show-file-list="false"
                            :on-success="handleIdCartUpImgSuccess"
                            :before-upload="beforeAvatarUpload"
                            :limit="1">
                            <img style=" width: 316px;height: 200px;" v-if="idcartUpImageUrl" :src="idcartUpImageUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传jpg/png格式的身份证正面照片</div>
                    </div>
                    <div style="float: left;margin-left: 20px;">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_down" placeholder="身份证反面照片"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                            :action="upload_path"
                            :show-file-list="false"
                            :on-success="handleIdCartDownImgSuccess"
                            :before-upload="beforeAvatarUpload"
                            :limit="1">
                            <img style=" width: 316px;height: 200px;" v-if="idcartDownImageUrl" :src="idcartDownImageUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传jpg/png格式的身份证反面照片</div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="银行卡照片">
                <el-input type="hidden" v-model="ruleForm.bankcard_img" placeholder="银行卡照片"
                          style="width: 100%;"></el-input>
                <el-upload
                    class="avatar-uploader"
                    :action="upload_path"
                    :show-file-list="false"
                    :on-success="handleBankCartImgSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img style=" width: 316px;height: 200px;" v-if="bankcartImageUrl" :src="bankcartImageUrl"
                         class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div>请上传jpg/png格式的银行卡照片</div>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[1, 1]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="协议详情" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false" :loop="false">
                <el-carousel-item v-for="(url, n) in allContractUrls" :key="n">
                    <div class="image_box" v-if="getFileType(url.src) == 'pdf'">
                        <pdf
                            v-for="i in url.pages"
                            :key="i"
                            :page="i"
                            :src="url.src" ></pdf>
                    </div>
                    <div class="image_box" v-if="getFileType(url.src) != 'pdf'">
                        <el-image :src="url.src"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>

    </div>

</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {VueCropper} from "vue-cropper";
import {fileType, isMobile} from "@/api/order";
import pdf from "vue-pdf";

export default {
    components: {
        VueCropper,
        pdf
    },
    created() {
        if (isMobile()) {
            this.form_width = '100%'
            this.form_min_width = 'none'
        }
        localStorage.setItem('prev_page', 'expert_add')
        let userData = getUserInfos();
        if (this.$route.query.user_id && this.$route.query.user_id != "") {
            this.user_id = this.$route.query.user_id;
        }
        this.ruleForm.input_user_name = userData.user_name;
        if (this.$route.params.hospital_department_id) {
            this.ruleForm.hospital_department_id = this.$route.params.hospital_department_id;
            this.hospitalDeparmentDisabled = true;
        }
    },
    mounted() {
        this.createParams();
    },
    data() {
        return {
            hospitalDeparmentDisabled: false,
            dialogContractFormVisible: false,
            hospitalDisabled: false,
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            userAvaratImageUrl: '',
            idcartUpImageUrl: '',
            idcartDownImageUrl: '',
            bankcartImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            formLabelWidth: '120px',
            fileList: [],
            addFileList: [],
            src: "",
            allContractUrls: [],
            user_id: '',
            ruleForm: {
                file: "",
                user_name: "",
                mobile: "",
                idcard: "",
                idcard_img_up: "",
                idcard_img_down: "",
                bank_card: "",
                bank_name: "",
                bankcard_img: "",
                hospital: "",
                hospital_department: "",
                doctor_title: "",
                degree: "",
                working_year: 1,
                strengths: '',
                status: 1,
                user_avatar: "",
                introduction: "",
                start_date: "", // 签约日期
                old_expired_date: "", // 旧签约日期
                contract_title: "", // 协议编号
                posistion: "", // 现任职务
                sort: "100", // 排序号
                group_name: "", // 编组
                age: "", // 年龄
            },
            rules: {
                user_name: [
                    {required: true, message: "请输入专家姓名", trigger: "blur"},
                ],
                mobile: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                ],
                idcard: [
                    {required: true, message: "请输入身份证号码", trigger: "blur"},
                ],
                bank_card: [
                    {required: true, message: "请输入银行卡号", trigger: "blur"},
                ],
                hospital: [
                    {required: true, message: "请选择单位", trigger: "blur"},
                ],
                hospital_department: [
                    {required: true, message: "请输入科室", trigger: "blur"},
                ],
                doctor_title: [
                    {required: true, message: "请输入职称", trigger: "blur"},
                ],
                degree: [
                    {required: false, message: "请输入学位", trigger: "blur"},
                ],
                working_year: [
                    {required: true, message: "请输入从业年限", trigger: "blur"},
                ],
                strengths: [
                    {required: true, message: "请选择擅长", trigger: "blur"},
                ],
                introduction: [
                    {required: true, message: "请输入学术任职", trigger: "blur"},
                ],
                user_avatar: [
                    {required: false, message: "请选择头像", trigger: "blur"},
                ],

            },
            dialogVisible: false,
            // 防止重复提交
            loading: false,
            option: {
                img: '',             //裁剪图片的地址
            },
            allHospital: [],
            hospitalDeparment: [],
            allDoctorTitle: [],
            form_min_width: '810px',
            form_width: '40%',
        };
    },
    methods: {
        getFileType(url) {
            return fileType(url)
        },
        // 所有咨询者，专家
        createParams() {

            if (this.user_id != '') {
                this.expertDetail();
            }
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'createParams',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allHospital = res.data.data.hospital;
                this.hospitalDeparment = res.data.data.hospital_department
                this.allDoctorTitle = res.data.data.doctor_title;
            });

        },
        yearChange(e) {
            this.ruleForm.working_year = parseInt(e)
        },
        expertDetail() {
            let params = {
                servername: 'Ruyi_AdminDoctorServices',
                method: 'expertDetail',
                params: {
                    user_id: this.user_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let data = res.data.data;
                this.ruleForm.user_name = data.user_name;
                this.ruleForm.mobile = data.mobile;
                this.ruleForm.idcard = data.idcard;
                this.ruleForm.bank_card = data.bank_card;
                this.ruleForm.bank_name = data.bank_name;
                this.ruleForm.hospital = data.hospital;

                this.ruleForm.hospital_department = data.hospital_department;
                this.ruleForm.doctor_title = data.doctor_title;
                this.ruleForm.degree = data.degree;
                this.ruleForm.working_year = data.working_year;
                this.ruleForm.strengths = data.strengths;
                this.ruleForm.sort = data.sort;
                this.ruleForm.group_name = data.group_name;
                this.ruleForm.age = data.age;
                this.ruleForm.status = parseInt(data.status);
                if (data.user_avatar) {
                    this.ruleForm.user_avatar = data.user_avatar;
                    this.userAvaratImageUrl = this.imgUrl + data.user_avatar;
                }

                if (data.bankcard_img) {
                    this.ruleForm.bankcard_img = data.bankcard_img;
                    this.bankcartImageUrl = this.imgUrl + data.bankcard_img;
                }
                if (data.idcard_img_up) {
                    this.ruleForm.idcard_img_up = data.idcard_img_up;
                    this.idcartUpImageUrl = this.imgUrl + data.idcard_img_up;
                }
                if (data.idcard_img_down) {
                    this.ruleForm.idcard_img_down = data.idcard_img_down;
                    this.idcartDownImageUrl = this.imgUrl + data.idcard_img_down;
                }
                this.ruleForm.introduction = data.introduction;
                // 协议部分
                this.ruleForm.start_date = data.start_date;
                this.ruleForm.contract_title = data.contract_title;
                this.ruleForm.posistion = data.posistion;
                // 协议文件
                if (data.contract_file != null) {
                    let file_arr = JSON.parse(data.contract_file)

                    let index = null;
                    let name = null;
                    for (let i = 0; i < file_arr.length; i++) {
                        index = file_arr[i].file.lastIndexOf("/");
                        name = file_arr[i].file.substring(index + 1, file_arr[i].file.length);
                        this.fileList.push({
                            response: {
                                data: {
                                    file: file_arr[i].file
                                }
                            },
                            name: name,
                            url: this.imgUrl + file_arr[i].file,
                        });
                        this.addFileList.push({
                            name: name,
                            file: file_arr[i].file,
                        });
                    }
                    this.ruleForm.file = "file";
                }


            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },

        // 提交表单
        submitForm(formName) {
            if (this.ruleForm.start_date && this.addFileList.length < 1) {
                this.$message({
                    type: "error",
                    message: "请上传协议文件",
                });
                return;
            }
            if (this.addFileList.length > 0 && !this.ruleForm.start_date) {
                this.$message({
                    type: "error",
                    message: "请选择签约日期",
                });
                return;
            }
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminDoctorServices',
                        'method': 'create',
                        'params': {
                            user_id: this.user_id,
                            user_name: this.ruleForm.user_name,
                            mobile: this.ruleForm.mobile,
                            idcard: this.ruleForm.idcard,
                            bank_card: this.ruleForm.bank_card,
                            bank_name: this.ruleForm.bank_name,
                            hospital: this.ruleForm.hospital,
                            hospital_department: this.ruleForm.hospital_department,
                            doctor_title: this.ruleForm.doctor_title,
                            degree: this.ruleForm.degree,
                            max_client: this.ruleForm.max_client,
                            status: this.ruleForm.status,
                            introduction: this.ruleForm.introduction,
                            strengths: this.ruleForm.strengths,
                            working_year: this.ruleForm.working_year,
                            user_avatar: this.ruleForm.user_avatar,
                            idcard_img_up: this.ruleForm.idcard_img_up,
                            idcard_img_down: this.ruleForm.idcard_img_down,
                            bankcard_img: this.ruleForm.bankcard_img,
                            protocol_file: this.addFileList,
                            start_date: this.ruleForm.start_date,
                            contract_title: this.ruleForm.contract_title,
                            posistion: this.ruleForm.posistion,
                            sort: this.ruleForm.sort,
                            group_name: this.ruleForm.group_name,
                            age: this.ruleForm.age,
                        }
                    };

                    if (this.user_id != '') {
                        params["method"] = "edit";
                    }
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        let mes = "创建成功";
                        if (this.user_id != '') {
                            mes = "修改成功"
                        }

                        this.$message({
                            type: "success",
                            message: mes,
                            duration: 1500,
                            onClose: function () {
                                window.history.go(-1);
                                return;
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    return false;
                }
            });
        },

        // 上传头像图片
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.user_avatar = res.data;
                this.userAvaratImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传身份证图片
        handleIdCartUpImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.idcard_img_up = res.data;
                this.idcartUpImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传身份证图片
        handleIdCartDownImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.idcard_img_down = res.data;
                this.idcartDownImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传银行卡图片
        handleBankCartImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.bankcard_img = res.data;
                this.bankcartImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 除去图片
        handleRemove(file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        addFileList.push(name);
                    }
                }
            }
            this.addFileList = addFileList;
        },
        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    // console.log(fileList[i].response)
                    if (fileList[i].response && fileList[i].response.data) {
                        if (fileList[i].response.data.file) {
                            addFileList.push(fileList[i].response.data);
                        } else {
                            addFileList.push({
                                file: fileList[i].response.data
                            });
                        }
                    }
                    // else {
                    //     let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                    //     let obj = {
                    //         file: name,
                    //         x: fileList[i].x,
                    //         y: fileList[i].y,
                    //     };
                    //     addFileList.push(obj);
                    // }
                }
            }

            this.addFileList = addFileList;
            this.ruleForm.file = "file";
        },
        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png/pdf格式!');
            }
            // if (!isLt5M) {
            //     isJPG = false;
            //     this.$message.error('图片大小不能超过5MB!');
            //
            // }
            return isJPG;
        },
        changeHospital() {
            this.hospitalDeparment = [];
            this.ruleForm.hospital_department_id = '';
            this.allHospitalDeparment.forEach(e => {
                if (e.hospital_id == this.ruleForm.hospital_id) {
                    this.hospitalDeparment.push(e);
                }
            });
        },
        getExpiredDate(type) {
            let baseDate = ''

            if (type == 2) {
                baseDate = this.ruleForm.old_expired_date
            } else {
                if (!this.ruleForm.start_date) return
                baseDate = this.ruleForm.start_date
            }

            let date = new Date(baseDate)
            let y = date.getFullYear() + this.ruleForm.year;
            let m = date.getMonth() + 1;
            let d = date.getDate()
            this.ruleForm.expired_date = `${y}-${m}-${d}`
        },
        //选择图片
        selectImg(e) {
            let file = e.target.files[0]

            if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                this.$message({
                    message: '图片类型要求：jpeg、jpg、png',
                    type: "error"
                });
                return false
            }
            //转化为blob
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.option.img = data
                this.dialogVisible = true;
            }
            //转化为base64
            reader.readAsDataURL(file)
        },
        //上传头像图片
        uploadImg(type) {
            let _this = this;
            if (type === 'blob') {
                //获取截图的blob数据
                this.$refs.cropper.getCropBlob(async (data) => {

                    let formData = new FormData();
                    formData.append('file', data, ".jpg")

                    await _this.$api.avatar_upload_file(formData).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code == 0) {
                            _this.ruleForm.user_avatar = res.data.data;
                            _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                            _this.dialogVisible = false;
                        } else {
                            _this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    })

                })
            }
        },
        // 关闭对话框清除之前选择的文件
        closeDialog() {
            document.getElementById('uploads').value = ''
            document.getElementById('suploads').value = ''
        },
        // 协议详情-预览
        async oneReservationDetail(data) {

            this.allContractUrls = [];
            let allContractUrls = [];
            if (data.contract_file) {
                let contract_file = JSON.parse(data.contract_file);
                let url = '';
                let local_url = '';
                let num_pages = 0;
                if (contract_file.length > 0) {
                    for (let i = 0; i < contract_file.length; i++) {
                        local_url = url = this.imgUrl + contract_file[i].file;
                        num_pages = 0;
                        if (this.getFileType(url) == 'pdf') {
                            url = pdf.createLoadingTask(url)
                            await url.promise.then(pdf => {
                                num_pages = pdf.numPages
                                allContractUrls.push({
                                    src: local_url,
                                    pages: num_pages
                                });
                            });

                        } else {
                            allContractUrls.push({
                                src: local_url,
                                pages: num_pages
                            });
                        }
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogContractFormVisible = true;
        },
        handleRemoveFile(file) {

            this.$refs.upload.handleRemove(file)
            for (let i = 0; i < this.addFileList.length; i++) {
                if (file.response.data.file == this.addFileList[i].file) {
                    this.addFileList.splice(i, 1);
                }
            }
        },
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}

.avatar{
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
}

.avatar-btn.avatar{
    width: 200px;
    height: 200px;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
